/** Textes écran succès Un Grand Marché (FR). */
export const unGrandMarcheFrSuccessCopy = {
  navCreation: 'CRÉATION',
  navMercerie: 'MERCERIE',
  navCosmetique: 'COSMÉTIQUE',
  searchPlaceholder: 'Je recherche une création, une boutique, une fourniture...',
  blog: 'Blog',
  subnav:
    'Accessoires · Bagagerie · Bijoux · Bébé · Enfants · Maison · Zéro déchet · Femme · Homme · Papeterie · Arts graphiques · Fournitures faites main',
  breadcrumbOrders: 'Commandes',
  breadcrumbFunds: 'Réception des fonds',
  paidLabel: 'Payé',
  buyerName: "Nom de l'acheteur :",
  buyerAddress: "Adresse de l'acheteur :",
  ctaReceive: 'Recevoir des fonds',
  trustPay: 'Paiement 100% sécurisé cryptage SSL',
  shippingLine:
    'Article expédié sous 2 jours ouvrés et à partir de 3,2 euros. En savoir plus',
  legalLinks: 'Conditions générales de vente du vendeur et Conditions de retours',
  loading: 'Chargement…',
};
